import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { OdooFicha, OdooFichaAccionRespuesta, OdooFichaCambios, OdooFichaMovimiento, OdooFichaTipo } from './odoo-ficha.models';
import { OdooRespuesta } from './odoo.models';

/** El historial ya trae lo enviado y respondido (`tecnico`): se expone con los nombres del detalle de la Bitácora. */
export function conDatos(m: OdooFichaMovimiento): OdooFichaMovimiento {
  const t = m.tecnico;
  return { ...m, datos: { peticion: t.enviado, respuesta: t.respuesta, status: t.estado_http, duracion_ms: t.duracion_ms, error: t.error } };
}

/**
 * «Gestión en Odoo» de la ficha del cliente o del comercio (el parámetro `tipo`, 'cliente' por omisión, elige la base).
 * Permisos: contactos.gestion_odoo.read / .write (cliente) y config.comercios_odoo.read / .write (comercio); los exige el servidor.
 */
@Injectable({ providedIn: 'root' })
export class OdooFichaService {
  private readonly bases: Record<OdooFichaTipo, string> = {
    cliente: `${environment.BASE_LA}/api/odoo/ficha`,
    comercio: `${environment.BASE_LA}/api/odoo/ficha-comercio`,
  };

  constructor(private http: HttpClient) {}

  private url(tipo: OdooFichaTipo, code: string, resto = ''): string { return `${this.bases[tipo]}/${encodeURIComponent(code)}${resto}`; }

  ficha(code: string, tipo: OdooFichaTipo = 'cliente'): Observable<OdooFicha> {
    return this.http.get<OdooRespuesta<OdooFicha>>(this.url(tipo, code)).pipe(map((r) => r.data));
  }

  /** Revisa y deja la línea «Revisar» en el historial. */
  revisar(code: string, tipo: OdooFichaTipo = 'cliente'): Observable<OdooFicha> {
    return this.http.post<OdooRespuesta<OdooFicha>>(this.url(tipo, code, '/revisar'), {}).pipe(map((r) => r.data));
  }

  anotar(code: string, tipo: OdooFichaTipo = 'cliente'): Observable<OdooFichaAccionRespuesta> {
    return this.http.post<OdooRespuesta<OdooFichaAccionRespuesta>>(this.url(tipo, code, '/anotar'), {}).pipe(map((r) => r.data));
  }

  actualizar(code: string, cambios: OdooFichaCambios, tipo: OdooFichaTipo = 'cliente'): Observable<OdooFichaAccionRespuesta> {
    return this.http.patch<OdooRespuesta<OdooFichaAccionRespuesta>>(this.url(tipo, code, '/actualizar'), cambios).pipe(map((r) => r.data));
  }

  movimientos(code: string, limit = 30, tipo: OdooFichaTipo = 'cliente'): Observable<OdooFichaMovimiento[]> {
    return this.http
      .get<OdooRespuesta<OdooFichaMovimiento[]>>(this.url(tipo, code, '/movimientos'), { params: new HttpParams().set('limit', String(limit)) })
      .pipe(map((r) => r.data.map(conDatos)));
  }
}
